import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import Route from "./routes";
import theme from "./styles/andtTheme";
import LoginProvider from "./model";
// console.log("process.env.REACT_APP_ENV===", process.env.REACT_APP_ENV);

function App() {
  return (
    <BrowserRouter
      basename={(window as any).__POWERED_BY_QIANKUN__ ? "/mic" : "/"}
    >
      <ConfigProvider prefixCls="crm-shop" theme={{ token: { ...theme } }}>
        <div className="App">
          <Suspense fallback={<></>}>
            <LoginProvider>
              <Route />
            </LoginProvider>
          </Suspense>
        </div>
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
